export default function BrandStatement() {
  return (
    <section className="bg-[#0E0C0A] py-32 md:py-40 px-8">
      <div className="max-w-2xl mx-auto text-center">
        <blockquote className="font-serif text-[#F0EBE3] text-2xl md:text-3xl lg:text-4xl leading-[1.5] font-light">
          We compose an <em className="italic text-[#C9A961]">atmosphere</em>,<br />
          orchestrate a <em className="italic text-[#C9A961]">moment</em>,<br />
          and leave a mark of quiet permanence.
        </blockquote>
        <div className="mt-12 h-px w-16 bg-[#C9A961]/40 mx-auto" />
      </div>
    </section>
  );
}
